var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7952 46.5686H6.20493C5.42906 46.5686 4.80005 45.9889 4.80005 45.2739V43.4615C4.80005 33.7056 13.4131 25.7686 24 25.7686C34.587 25.7686 43.2001 33.7055 43.2001 43.4615V45.2739C43.2001 45.9889 42.571 46.5686 41.7952 46.5686Z",
    fill: "url(#paint0_linear_24094_6635)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 24.1687C18.7067 24.1687 14.4001 20.2969 14.4001 15.5379V11.9994C14.4001 7.24039 18.7067 3.36865 24.0001 3.36865C29.2936 3.36865 33.6001 7.24039 33.6001 11.9994V15.5379C33.6001 20.2969 29.2936 24.1687 24.0001 24.1687Z",
    fill: "url(#paint1_linear_24094_6635)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24094_6635",
    x1: 4.80005,
    y1: 36.1686,
    x2: 43.2001,
    y2: 36.1686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24094_6635",
    x1: 14.4001,
    y1: 13.7687,
    x2: 33.6001,
    y2: 13.7687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.b462b3056dc33c1e514616cb1c28cfbb.svg";
export { ForwardRef as ReactComponent };